import {
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';
import {
  fetchProductGroupsData,
  fetchSingleProductGroup,
  setProductGroupsList,
  setViewedProductGroup,
  addAssociation,
  deleteAssociation,
  setErrorMessage,
} from './actions';
import { getProductGroups, getViewedProductGroup } from './selectors';
import {
  BASE_URL,
  PRODUCT_GROUP_ASSOCIATIONS_URL,
  PRODUCT_GROUPS_URL,
} from '../../config';
import getUrlFiltered from '../../utils/helper_functions/getUrlFiltered';
import { setLoader } from '../loader/actions';

function* fetchProductGroups(action) {
  const productGroups = yield select(getProductGroups);
  if (action.payload.filterName) {
    const response = yield call(fetch, getUrlFiltered(
      PRODUCT_GROUPS_URL,
      {
        [`${action.payload.filterName}`]: action.payload.filterValue,
      },
    ));

    const data = yield response.json();
    yield put(setProductGroupsList({
      all: { ...productGroups.all },
      filtered: data,
    }));
  } else {
    const response = yield call(fetch, getUrlFiltered(PRODUCT_GROUPS_URL));
    const data = yield response.json();
    yield put(setProductGroupsList({
      all: data,
      filtered: data,
    }));
  }
}

export function* fetchProductGroupsSaga(action) {
  yield put(setLoader('associations', true));
  yield call(fetchProductGroups, action);
  yield put(setLoader('associations', false));
}

export function* fetchSingleProductGroupSaga(action) {
  yield put(setLoader('singleAssociation', true));
  const response = yield call(fetch, getUrlFiltered(
    PRODUCT_GROUP_ASSOCIATIONS_URL,
    {
      productGroup: action.payload.productGroupNumber,
    },
  ));

  const data = yield response.json();
  yield put(setViewedProductGroup(
    {
      ...data,
      number: action.payload.productGroupNumber,
      productIRI: action.payload.productIRI,
      products: action.payload.products,
    },
  ));
  yield put(setLoader('singleAssociation', false));
}

export function* addAssociationSaga(action) {
  yield put(setLoader('singleAssociation', true));
  const response = yield call(fetch, getUrlFiltered(PRODUCT_GROUP_ASSOCIATIONS_URL), {
    method: 'POST',
    body: JSON.stringify({
      multiplier: action.payload.multiplier || null,
      productGroup: action.payload.groupIRI,
      associatedProductGroup: action.payload.associationIRI,
    }),
    headers: {
      'Content-Type': 'application/ld+json',
    },
  });

  const data = yield response.json();
  yield put(setErrorMessage(data.violations));
  const { number, productIRI, products } = yield select(getViewedProductGroup);
  yield put(fetchSingleProductGroup(
    number,
    productIRI,
    products,
  ));
}

export function* deleteAssociationSaga(action) {
  yield put(setLoader('singleAssociation', true));
  yield call(fetch, (BASE_URL + action.payload.associationIRI), {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/ld+json',
    },
  });

  const { number, productIRI, products } = yield select(getViewedProductGroup);
  yield put(fetchSingleProductGroup(
    number,
    productIRI,
    products,
  ));
}

export function* watchFetchProductGroupsSaga() {
  yield takeEvery(String(fetchProductGroupsData), fetchProductGroupsSaga);
}

export function* watchFetchSingleProductGroupSaga() {
  yield takeEvery(String(fetchSingleProductGroup), fetchSingleProductGroupSaga);
}

export function* watchAddAssociationSaga() {
  yield takeEvery(String(addAssociation), addAssociationSaga);
}

export function* watchDeleteAssociationSaga() {
  yield takeEvery(String(deleteAssociation), deleteAssociationSaga);
}
